<div class="dialog">
	<ng-container mat-dialog-content>
		<div class="dialog__content">
			<gaw-game-result-dialog-content
				[type]="gameResultType"
				[strokesCount]="dialogData.strokesCount"
			/>
		</div>
	</ng-container>
	<ng-container mat-dialog-actions>
		<div class="dialog__actions">
			<button
				(click)="onStart()"
				type="button"
				class="primary"
			>
				<mat-icon svgIcon="play" />
				Play again
			</button>
			<!-- TODO (Sherstkov) Delete 'hide' class when implementation is ready -->
			<button
				(click)="onShare()"
				type="button"
				class="secondary visually-hidden"
			>
				Share
			</button>
		</div>
	</ng-container>
</div>
